
import React from 'react'
import { OutboundBuddyLogo } from './OutboundBuddyLogo'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  message?: string
  className?: string
}

export function LoadingSpinner({ size = 'md', message, className = '' }: LoadingSpinnerProps) {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <OutboundBuddyLogo size={size} animated />
      {message && (
        <p className="text-sm text-muted-foreground font-sora">{message}</p>
      )}
    </div>
  )
}
